module.exports = __webpack_public_path__ + "assets/33b9ec0482bdc82eaf9cae71a40d4981.png";